import styled from 'styled-components'

export const Container = styled.ul(({ theme }) => ({
  alignItems: 'center',
  color: theme.colors.black100,
  display: 'flex',
  flexDirection: 'row',
  gap: theme.space['8'],
}))

export const Content = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.space['2'],
}))
